@if (home) {
  <div>
    <mat-toolbar color="primary" ngClass.lt-sm="toolbar-small-devices">
      <mat-toolbar-row fxLayout="row">
        @if (hotfixShowMenu && activatedAccount()) {
          <img (click)="clickLateralMenu()" alt="menu inextenso mon compte"
            class="menu" ngClass.lt-sm="icon-small-devices" src="/assets/burger.svg"/>
        }
        <img class="logo" src="/assets/logo.png" ngClass.lt-sm="logo-small-devices" alt="logo inextenso mon compte"/>
        <span class="spacer"></span>
        <a class="material-icons account_button faq_button" href="https://faq-moncompte.inextenso.fr"
        target="_blank" ngClass.lt-sm="icon-small-devices">help</a>
        @if (isAuthenticated() && activatedAccount()) {
          <i (click)="clickAccountMenu()"
          class="material-icons account_button" ngClass.lt-sm="icon-small-devices">person</i>
        }
      </mat-toolbar-row>
    </mat-toolbar>
    @if (showAccountMenu) {
      <div class="account_menu">
        <div [routerLink]="'/informations'" class="account_button_account_menu">
          <mat-icon>settings</mat-icon>
          <span class="label_account_menu">Mon compte</span>
        </div>
        <div (click)="logout();" class="logout_button_account_menu">
          <mat-icon>power_settings_new</mat-icon>
          <span class="label_account_menu">Déconnexion</span>
        </div>
      </div>
    }
    @if (innerWidth <= 500 && showSidenavMenu && hotfixShowMenu && activatedAccount()) {
      <div class="lateral_menu_small">
        @if (isAuthenticated()&&tiersSelected()) {
          <div [routerLink]="'/summary'" class="account_button_account_menu">
            <mat-icon>notes</mat-icon>
            <span class="label_account_menu">Accueil</span>
          </div>
        }
        @if (isAuthenticated()&&tiersSelected()) {
          <div [routerLink]="'/bills'" class="account_button_account_menu">
            <mat-icon>assignment_turned_in</mat-icon>
            <span class="label_account_menu">Mes factures non réglées</span>
          </div>
        }
        @if (isAuthenticated()) {
          <div [routerLink]="'/switch-company'" class="account_button_account_menu">
            <mat-icon>business</mat-icon>
            <span class="label_account_menu">Gérer mes entreprises</span>
          </div>
        }
        @if (isAuthenticated()&&activeModuleMandat()&&tiersSelected()) {
          <div [routerLink]="'/mandat'"
            class="account_button_account_menu">
            <mat-icon>euro_symbol</mat-icon>
            <span class="label_account_menu">M'abonner au prélèvement</span>
          </div>
        }
        @if (!isAuthenticated()) {
          <div [routerLink]="'/login'" class="account_button_account_menu">
            <mat-icon>lock</mat-icon>
            <span class="label_account_menu">Se connecter</span>
          </div>
        }
        @if (!isAuthenticated()) {
          <div [routerLink]="'/register'" class="account_button_account_menu">
            <mat-icon>library_add</mat-icon>
            <span class="label_account_menu">Créer mon compte</span>
          </div>
        }
        @if (!isAuthenticated()) {
          <div [routerLink]="'/reset-password'" class="account_button_account_menu">
            <mat-icon>refresh</mat-icon>
            <span class="label_account_menu">Réinitialiser mon mot de passe</span>
          </div>
        }
      </div>
    }
    <div class="container">
      @if (showSidenavMenu && hotfixShowMenu && innerWidth > 500 && activatedAccount()) {
        <div class="lateral_menu">
          <mat-nav-list>
            @if (isAuthenticated()&&tiersSelected()) {
              <a [routerLink]="'/summary'" mat-list-item>
                <mat-icon matTooltip="Accueil" matTooltipPosition="right">notes</mat-icon>
              </a>
            }
            @if (isAuthenticated()&&tiersSelected()) {
              <a [routerLink]="'/bills'" mat-list-item>
                <mat-icon matTooltip="Mes factures non réglées" matTooltipPosition="right">assignment_turned_in</mat-icon>
              </a>
            }
            @if (isAuthenticated()) {
              <a [routerLink]="'/switch-company'" mat-list-item>
                <mat-icon matTooltip="Gérer mes entreprises" matTooltipPosition="right">business</mat-icon>
              </a>
            }
            @if (isAuthenticated()&&activeModuleMandat()&&tiersSelected()) {
              <a [routerLink]="'/mandat'" mat-list-item>
                <mat-icon matTooltip="M'abonner au prélèvement" matTooltipPosition="right">euro_symbol</mat-icon>
              </a>
            }
            @if (!isAuthenticated()) {
              <a [routerLink]="'/login'" mat-list-item>
                <mat-icon matTooltip="Se connecter" matTooltipPosition="right">lock</mat-icon>
              </a>
            }
            @if (!isAuthenticated()) {
              <a [routerLink]="'/register'" mat-list-item>
                <mat-icon matTooltip="Créer mon compte" matTooltipPosition="right">library_add</mat-icon>
              </a>
            }
            @if (!isAuthenticated()) {
              <a [routerLink]="'/reset-password'" mat-list-item>
                <mat-icon matTooltip="Réinitialiser mon mot de passe" matTooltipPosition="right">refresh</mat-icon>
              </a>
            }
          </mat-nav-list>
        </div>
      }
      <div class="content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
}
